module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Honey.b66f632b.png";